import { createRoot } from 'react-dom/client'

import { ThemeProvider } from '@emotion/react'
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { tokens } from '@ugleelab/design-system/tokens'

import { setupBridgeMock } from '@onl-web/shared/bridge'
import { WebViewGuard } from '@onl-web/shared/guard'

import App from './App'
import GlobalErrorBoundary from './components/GlobalErrorBoundary'
import { reportApiFailure } from './components/GlobalErrorBoundary/reportApiFailure'
import { APP_REDIRECT_URL } from './constants'
import { initSentry } from './lib/sentry'
import GlobalStyles from './styles/GlobalStyles'

import '@ugleelab/design-system/styles.css'

initSentry()

if (import.meta.env.DEV) {
  setupBridgeMock({
    getToken: () => ({ token: 'dev-mock-token', bottom: '15' }),
  })
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      reportApiFailure(error)
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      reportApiFailure(error)
    },
  }),
})

createRoot(document.getElementById('root')!).render(
  <WebViewGuard fallbackUrl={APP_REDIRECT_URL}>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={tokens}>
        <GlobalStyles />
        <GlobalErrorBoundary>
          <App />
        </GlobalErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  </WebViewGuard>
)
